/* eslint-disable @typescript-eslint/no-explicit-any */

export function getRealBsiItems(value: any) {
  return Array.isArray(value?.bsi)
    ? value.bsi.filter((item: any) => item?.id || item?.depth || item?.ppk)
    : []
}

export function getGraphDayState(value: any) {
  const planCode = Number(value?.plan || 0)
  const ppkLimit = value?.ppk_limit || null
  const ppkPending = value?.ppk_pending || null
  const ppkLimitDepth = Number(ppkLimit?.depth || 0)
  const fullPassDepth = ppkLimitDepth > 0 ? ppkLimitDepth : 900
  const fullPassMinDepth = Math.max(0, fullPassDepth - 5)
  const bsiItems = getRealBsiItems(value)
  const maxDepth = bsiItems.reduce((max: number, item: any) => (
    Math.max(max, Number(item.depth || 0))
  ), 0)
  const hasBsi = bsiItems.length > 0
  const hasFullPass = hasBsi && maxDepth >= fullPassMinDepth
  const hasShortPass = hasBsi && maxDepth < fullPassMinDepth
  const manualDepth = Number(value?.depth || 0)
  const hasManualFullPass = !hasBsi && manualDepth >= fullPassMinDepth
  const rawReason = value?.comment?.label || value?.comment?.name || value?.comment || ''
  const reason = rawReason
    || value?.comment?.name
    || value?.comment
    || ppkPending?.message
    || ''

  const result = (kind: string, depth = maxDepth) => ({
    kind,
    planCode,
    bsiItems,
    maxDepth: depth,
    fullPassDepth,
    fullPassMinDepth,
    ppkLimit,
    ppkPending,
    reason,
  })

  if (!value || typeof value !== 'object') {
    return result('empty')
  }

  if (ppkPending && (hasBsi || manualDepth > 0 || rawReason)) {
    return result('ppk_pending', hasBsi ? maxDepth : manualDepth)
  }

  if (planCode === 4 && !hasBsi && reason) {
    return result('reason')
  }

  if (planCode === 4 && hasShortPass) {
    return result('no_pass')
  }

  if (planCode === 2 && hasManualFullPass) {
    return result('manual_planned', manualDepth)
  }

  if (planCode === 3 && hasFullPass) {
    return result('done_outside_plan')
  }

  if (planCode === 3 && hasManualFullPass) {
    return result('manual_outside_plan', manualDepth)
  }

  if ((planCode === 1 || planCode === 2) && hasFullPass) {
    return result('done_planned')
  }

  if (hasFullPass) {
    return result('done')
  }

  if (hasShortPass) {
    return result('no_pass')
  }

  if (planCode === 1) {
    return result('planned')
  }

  return result('empty')
}
